import type { ID } from '@octopus-do/octopus-project-core'
import type {
  AccessState,
  TeammateDto,
  Workspace,
  WorkspaceItem,
} from '@store/reducers/dashboard/types'

import { DisabledRoles, RoleOrder } from './constants'

const compareMembers = (a: TeammateDto, b: TeammateDto) =>
  RoleOrder[b.role] - RoleOrder[a.role]

const takeDisabled = (members: TeammateDto[]) =>
  members.filter((m) => DisabledRoles.includes(m.role)).map((m) => m.id)

const takeChecked = (
  state: AccessState | null,
  members: TeammateDto[],
  disabled: ID[]
) => {
  if (!state) {
    return []
  }

  if (state.visibility === 'public') {
    return members.map(({ id }) => id)
  }

  return members
    .filter((m) => disabled.includes(m.id) || state.members.includes(m.id))
    .map((m) => m.id)
}

export const findFolder = (workspace: Workspace | null, folderId: ID) =>
  (workspace?.folders || []).find((f) => f.id === folderId) || null

export const takeAccessState = (
  folder: WorkspaceItem | null,
  members: TeammateDto[]
) => {
  const publicAccess = folder?.visibility === 'public'
  const disabled = publicAccess ? [] : takeDisabled(members)
  const checked = takeChecked(folder, members, disabled)

  const availableUsers = members
    .filter((m) => m.activity === 'active')
    .sort(compareMembers)

  return { members: availableUsers, disabled, publicAccess, checked }
}
